import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaCheck,
  FaHandScissors,
  FaLink,
  FaMagic,
  FaTicketAlt,
} from "react-icons/fa";
import "./App.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
function App() {
  const [url, setUrl] = useState("");
  const [data, setData] = useState({});

  const handleSubmit = () => {
    axios
      .post(
        "https://api-ssl.bitly.com/v4/shorten",
        {
          long_url: url,
          domain: "bit.ly",
        },
        {
          headers: {
            Authorization: "Bearer 5837b3be254442de26f04fd9174d3041765668e0",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => setData(response.data))
      .catch((error) => console.log(error));
  };

  return (
    <div className="App">
      <div className="container">
        <div className="intro">
          <h1 className="fw-bold">Short It</h1>
          <ul>
            <li>
              <FaCheck color="green" /> Easily cut your long links into short
            </li>
            <li>
              <FaCheck color="green" /> Enjoy
            </li>
          </ul>
        </div>
        <div className="content-box">
          <label>
            <FaLink fontSize={15} /> Enter your long URL:
          </label>
          <input
            type="text"
            placeholder="Paste your URL here"
            onChange={(e) => setUrl(e.target.value)}
            className="input"
          />
          <label>
            <FaMagic fontSize={15} /> Your short URL:
          </label>
          <input
            type="text"
            placeholder="Your short URL"
            className="short-url"
            value={data.link}
            readOnly
          />

          <button type="submit" onClick={handleSubmit}>
            Short It <FaHandScissors fontSize={15} className="icon" />
          </button>
        </div>
      </div>
      <footer>Copyright @ 2023. Salman Haider</footer>
    </div>
  );
}

export default App;
